// removed by extract-text-webpack-plugin
module.exports = {"picker":"_2oQe3pA-pXWeTrFwBQ6tKr","pick":"_2OqjsLXteR-yKLTDcKLzg3"};


//////////////////
// WEBPACK FOOTER
// ./app/components/UserPicker/style.scss
// module id = 1044
// module chunks = 0